var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.916504 5.5C0.916504 3.98122 2.14772 2.75 3.6665 2.75H18.3332C19.852 2.75 21.0832 3.98122 21.0832 5.5V16.5C21.0832 18.0188 19.852 19.25 18.3332 19.25H3.6665C2.14772 19.25 0.916504 18.0188 0.916504 16.5V5.5ZM3.6665 4.58333C3.16024 4.58333 2.74984 4.99374 2.74984 5.5V6.81433L10.9998 11.7643L19.2498 6.81433V5.5C19.2498 4.99374 18.8394 4.58333 18.3332 4.58333H3.6665ZM19.2498 8.95234L11.9431 13.3364C11.3625 13.6847 10.6372 13.6847 10.0566 13.3364L2.74984 8.95234V16.5C2.74984 17.0063 3.16024 17.4167 3.6665 17.4167H18.3332C18.8394 17.4167 19.2498 17.0063 19.2498 16.5V8.95234Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.5efe75153eda19070ad32f7dbece4dc3.svg";
export { ForwardRef as ReactComponent };